import { createContext, useContext } from 'react';

/**
 * Cascade channel from `PageHeader.Meta` to its `PageHeader.MetaItem`
 * descendants. When `Meta` sets `isLoading`, the value here becomes `true`
 * and every descendant `MetaItem` without its own explicit `isLoading` prop
 * inherits it.
 *
 * See ADR-006.
 */
const MetaLoadingContext = createContext<boolean>(false);

export const MetaLoadingProvider = MetaLoadingContext.Provider;

export const useIsMetaLoading = () => useContext(MetaLoadingContext);
